// pages/Shop.jsx
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom'; // ✅ Added useNavigate
import { SearchIcon, FilterIcon } from '../../../public/icons';
import { 
  GiftSomethingBackground, 
  RememberBackground, 
  DiscountBanner, 
  AudioGift, 
  Legacy, 
  Frame, 
  NameAndMeaning, 
  Heritage, 
  Custom2
} from '../../../public/images/shop';

const Shop = () => {
  const [searchQuery, setSearchQuery] = useState('');
  const navigate = useNavigate(); // ✅ Init navigate

  // Product data array
  const products = [
       {
      id: 'memory-magnet',
      title: 'Custom Memory Magnet',
      description: 'A small but powerful keepsake - a magnet that opens a protected digital memory when scanned.',
      image: Custom2,
      onClick: () => navigate('/memory-magnets/edit-template', {
        state: {
          isCustom: true,
          productFamily: 'Memory Magnets',
          title: 'Custom Memory Magnet',
          description: 'Upload your photo, write your story, and turn it into a magnet that holds meaning.',
          price: 30000
        }
      })
    },
    {
      id: 'heritage-magnet',
      title: 'Heritage Magnet',
      description: 'Heritage Magnets are culturally or historically inspired magnet collections.',
      image: Heritage, 
      // ✅ Pass the correct state
      onClick: () => navigate('/memory-magnets/other-template', {
        state: {
          productFamily: 'Heritage Magnet',
          collectionName: 'Nigeria — Travel Memory Magnet', // Uses the existing fallback data
          collectionDescription: 'Heritage Magnets are culturally or historically inspired magnet collections.'
        }
      })
    },
    {
      id: 'names-meaning',
      title: 'Names & their meaning Magnet',
      description: 'Heritage Magnets are culturally or historically inspired magnet collections.',
      image: NameAndMeaning,
      // ✅ Pass the correct state
      onClick: () => navigate('/memory-magnets/other-template', {
        state: {
          productFamily: 'Names & their meaning Magnet',
          collectionName: 'Names & their meaning Magnet', // Matches the key in MemoryMagnetsDetails data
          collectionDescription: 'Heritage Magnets are culturally or historically inspired magnet collections.'
        }
      })
    },
    {
      id: 'frame-it-forward',
      title: 'Frame it Forward',
      description: 'A timeless frame with a hidden QR code that opens your personal memory.',
      image: Frame,
      onClick: () => navigate('/frame-it-Forward-edit/edit-template')
    },
    {
      id: 'legacy-magnet',
      title: 'Legacy Magnet',
      description: 'A beautifully crafted box for birthdays, anniversaries, and intimate celebrations',
      image: Legacy,
      onClick: () => navigate('/legacy-magnets/edit-template')
    },
    {
      id: 'audio-gift',
      title: 'Audio Gift',
      description: 'A beautifully crafted box for birthdays, anniversaries, and intimate celebrations',
      image: AudioGift,
      onClick: () => navigate('/audio-gifts/edit-template')
    }
  ];

  return (
    <div className="min-h-screen bg-[#FCF7EE] pt-20 pb-20 text-left">
      
      {/* TOP HEADER SECTION */}
      <section className="container mx-auto px-4 max-w-7xl mb-12">
        <div className="flex flex-col lg:flex-row justify-between items-start lg:items-end gap-8">
          <div className="max-w-xl">
            <h1 className="text-4xl md:text-5xl font-bold text-[#1C2A46] mb-4">
              Shop
            </h1>
            <p className="text-[#6B635D] text-base md:text-lg leading-relaxed">
              A collection of memory magnets inspired by iconic places across Nigeria, each one telling a story of culture, history, and meaning.
            </p>
          </div>

          <div className="flex flex-col sm:flex-row gap-3 w-full lg:w-auto">
            <div className="relative w-full sm:w-[280px] md:w-[320px]">
              <input
                type="text"
                placeholder="search products..."
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                className="p-3 pr-12 border w-full border-[#DBDBDB] bg-transparent placeholder:text-[#6B635D] placeholder:font-light focus:outline-none focus:border-[#1C2A46] transition-colors"
              />
              <div className="absolute right-4 top-1/2 transform -translate-y-1/2 text-[#6B635D]">
                <SearchIcon size={20} />
              </div>
            </div>

            <button className="flex items-center justify-center gap-2 px-6 py-3 border border-[#DBDBDB] bg-transparent hover:bg-[#F8F8F8] transition-colors w-full sm:w-auto">
              <FilterIcon />
              <span className="text-[#1C2A46]">Filter</span>
            </button>
          </div>
        </div>
      </section>

      {/* PRODUCTS GRID */}
      <section className="container mx-auto px-4 max-w-7xl mb-20">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-x-6 gap-y-12">
          {products.map((product) => (
            <div 
              key={product.id} 
              onClick={product.onClick}
              className="group flex flex-col h-full cursor-pointer"
            >
              <div className="mb-5 overflow-hidden bg-[#F5F5F5]">
                <img 
                  src={product.image} 
                  alt={product.title} 
                  className="w-[392px] h-[496px] object-cover transition-transform duration-500 group-hover:scale-105" 
                />
              </div>

              <div className="flex-grow">
                <h3 className="text-xl font-medium text-[#1C2A46] mb-2">
                  {product.title}
                </h3>
                <p className="text-[#6B635D] text-sm md:text-base font-light leading-relaxed mb-6">
                  {product.description}
                </p>
              </div>

              <div className="mt-auto">
                <button className="w-full py-3.5 border border-[#DBDBDB] text-[#1C2A46] text-sm font-medium hover:bg-[#1C2A46] hover:text-white transition-all duration-300">
                  Explore
                </button>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* DISCOUNT BANNER */}
      <div className="container mx-auto px-4 max-w-7xl mb-20">
        <img src={DiscountBanner} alt="Discount Banner" className="w-full h-auto" />
      </div>

      {/* HOW PEOPLE USE KAPTA SECTION */}
      <section className="py-20 bg-[#FCF7EE]">
        <div className="container mx-auto px-4 max-w-7xl">
          <div className="text-center mb-16">
            <div className="flex items-center justify-center gap-3 mb-6">
              <div className="w-2 h-2 bg-[#D4A574] rounded-full"></div>
              <p className="text-[#8B7355] font-medium uppercase tracking-wide text-sm">How People Use Kapta</p>
            </div>
            <h2 className="text-4xl md:text-5xl font-bold text-[#1C2A46] leading-tight">
              Different Stories
              <br />
              <span className="text-[#1C2A46]">Different Ways to Remember</span>
            </h2>
          </div>

          <div className="flex flex-col md:flex-row gap-6">
            <div className="relative group cursor-pointer md:w-[67%] h-[440px]">
              <div className="relative overflow-hidden bg-white h-full">
                <div className="h-full relative">
                  <img
                    src={RememberBackground}
                    alt="A minimalist white vessel or container"
                    className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent opacity-80"></div>
                </div>
                <div className="absolute bottom-0 left-0 right-0 py-10 px-6 text-white">
                  <h3 className="text-2xl md:text-3xl font-bold mb-2 leading-tight text-left">
                    To remember a place,<br />
                    moment, or feeling
                  </h3>
                  <p className="text-white/90 text-lg text-left">
                    A trip. A season. A memory you don't want to forget.
                  </p>
                </div>
              </div>
            </div>

            <div className="relative group cursor-pointer md:w-[33%] h-[440px]">
              <div className="relative overflow-hidden h-full">
                <div className="h-full relative">
                  <img
                    src={GiftSomethingBackground}
                    alt="A beautifully set table with gift, candles, and flowers"
                    className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent opacity-80"></div>
                </div>
                <div className="absolute bottom-0 left-0 right-0 py-10 px-6 text-white">
                  <h3 className="text-2xl md:text-3xl font-bold mb-2 leading-tight text-left">
                    To gift something<br />
                    meaningful
                  </h3>
                  <p className="text-white/90 text-lg text-left">
                   Not just an object — but a message, a voice, a story.  
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Shop;